import React from "react";
import { AppBar, Toolbar, Box, ListItem } from "@mui/material";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

function Manager() {
	const theme = useTheme();
	const location = useLocation();
	const { t } = useTranslation();
	const links = [
		{ text: t("nettWorth"), path: "/manager/nettworth" },
		{ text: t("cashflow"), path: "/manager/cashflow" },
		{ text: t("budget"), path: "/manager/budget" },
		{ text: t("goals"), path: "/manager/goals" },
	];
	return (
		<>
			<AppBar
				position="static"
				elevation={0}
				sx={{
					background: theme.palette.background.default,
				}}
			>
				<Toolbar disableGutters sx={{ px: 2 }}>
					<Box
						sx={{
							marginLeft: "auto",
							display: "flex",
							gap: 0,
						}}
					>
						{links.map((link) => (
							<ListItem
								key={link.path}
								component={NavLink}
								to={link.path}
								sx={{
									textDecoration: "none",
									borderRadius: "10px",
									px: 2,
									py: 1,
									color: theme.palette.text.primary,
									backgroundColor:
										location.pathname.startsWith(link.path)
											? theme.palette.active.main
											: theme.palette.background.default,
									textWrap: "nowrap",
									"&:hover": {
										backgroundColor: "action.hover",
									},
								}}
							>
								{link.text}
							</ListItem>
						))}
					</Box>
				</Toolbar>
			</AppBar>

			<Outlet />
		</>
	);
}

export default Manager;
